import { defineComponent } from 'vue';
import CampaignImportBannerCode from '@/presentation/components/entities-and-geotargeting/campaign-import-banner/campaign-import-banner.code';

export default defineComponent({
	setup: () => {
		const code = new CampaignImportBannerCode();

		return {
			details: code.details,
			dismiss: code.dismiss.bind(code)
		};
	}
});
